import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterBar = ({ 
  statusFilter, 
  setStatusFilter, 
  dateRange, 
  setDateRange, 
  searchQuery, 
  setSearchQuery 
}) => {
  const { t } = useTranslation();

  const statusOptions = [
    { value: 'all', label: t('dashboard.filters.all') },
    { value: 'published', label: t('dashboard.filters.published') },
    { value: 'draft', label: t('dashboard.filters.draft') }
  ];

  const dateRangeOptions = [
    { value: 'all', label: t('dashboard.filters.all') },
    { value: 'today', label: t('dashboard.filters.today') },
    { value: 'week', label: t('dashboard.filters.week') },
    { value: 'month', label: t('dashboard.filters.month') },
    { value: 'quarter', label: t('dashboard.filters.quarter') },
    { value: 'year', label: t('dashboard.filters.year') }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-sm mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" 
            />
            <Input
              type="search"
              placeholder={t('dashboard.filters.searchPlaceholder')}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="pl-10"
            />
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 lg:w-auto">
          <div className="w-full sm:w-48">
            <Select
              options={statusOptions}
              value={statusFilter}
              onChange={setStatusFilter}
              placeholder={t('dashboard.filters.status')}
            />
          </div>
          
          <div className="w-full sm:w-48">
            <Select
              options={dateRangeOptions}
              value={dateRange}
              onChange={setDateRange}
              placeholder={t('dashboard.filters.dateRange')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;